import {DIALOG_TYPE, LayoutConfig} from "@spartacus/storefront";
import {
  GonvarriSavedCartFormDialogComponent
} from "../components/gonvarri-saved-cart-form-dialog/gonvarri-saved-cart-form-dialog.component";

export const gonvarriDefaultAddToSavedCartLayoutConfig: LayoutConfig = {
  launch: {
    GONVARRI_SAVED_CART: {
      inlineRoot: true,
      component: GonvarriSavedCartFormDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
  },
};

export const defaultSavedCartFormLayoutConfig: LayoutConfig = {
  launch: {
    SAVED_CART: {
      inline: true,
        component: GonvarriSavedCartFormDialogComponent,
        dialogType: DIALOG_TYPE.DIALOG,
    },
  },
}
